import React from 'react';
import asyncComponent from 'util/asyncComponent';
import AdminContainer from 'containers/admin/AdminContainer';
import AppContainer from 'containers/app/AppContainer';
import { INVOICE_MANAGEMENT } from 'constants/features';
import { isAssistantLaunched } from 'pages/app/assistant/assistantLaunch';

const platform = ['shopify'];

export default [
  {
    path: '/signin',
    component: asyncComponent(() => import('pages/signin/SignIn'))
  },
  {
    path: '/signout',
    component: asyncComponent(() => import('pages/signin/SignOut'))
  },
  {
    path: '/email-confirmation',
    component: asyncComponent(() =>
      import('pages/emailConfirmation/EmailConfirmation')
    )
  },
  {
    path: '/confirm-invite',
    component: asyncComponent(() => import('pages/confirmInvite/ConfirmInvite'))
  },
  {
    path: '/signup',
    component: asyncComponent(() => import('pages/signup/SignUp'))
  },
  {
    path: '/partners/signup',
    component: asyncComponent(() => import('pages/signup/PartnerSignUp'))
  },
  {
    path: '/terms-of-use',
    component: asyncComponent(() => import('pages/signup/TermsOfUse'))
  },
  {
    path: '/integrated-cities',
    component: asyncComponent(() => import('pages/public/IntegratedCities'))
  },
  {
    path: '/platforms',
    component: asyncComponent(() => import('pages/public/IntegratedPlatforms'))
  },
  {
    path: '/pay/:paymentid',
    component: asyncComponent(() => import('pages/public/SubscriptionPayment'))
  },
  {
    path: '/store/digital-certificate',
    component: asyncComponent(() =>
      import('pages/public/CertificateLandingPage')
    )
  },
  {
    path: '/store/checkout',
    exact: true,
    component: asyncComponent(() => import('pages/public/StoreOrderPayment'))
  },
  {
    path: '/store/checkout/pix/:orderId',
    component: asyncComponent(() => import('pages/public/StoreOrderPaymentPix'))
  },
  {
    path: '/store/checkout/success',
    component: asyncComponent(() =>
      import('pages/public/StoreOrderPaymentSuccess')
    )
  },
  {
    path: '/forgot-password',
    component: asyncComponent(() =>
      import('pages/forgotpassword/ForgotPassword')
    )
  },
  {
    path: '/public/product-invoices/:invoiceid/pdf',
    component: asyncComponent(() => import('pages/app/orders/OrderInvoiceView'))
  },
  {
    path: '/public/service-invoices/:invoiceid/pdf',
    component: asyncComponent(() => import('pages/app/orders/OrderInvoiceView'))
  },
  {
    path: '/public/consumer-invoices/:invoiceid/pdf',
    component: asyncComponent(() => import('pages/app/orders/OrderInvoiceView'))
  },
  {
    path: '/reset-password',
    component: asyncComponent(() =>
      import('pages/forgotpassword/ResetPassword')
    )
  },
  {
    path: '/apps/authorize',
    exact: true,
    component: asyncComponent(() =>
      import('pages/app/platforms/PlatformAuthorize')
    )
  },
  {
    path: '/oauth/consent',
    exact: true,
    component: asyncComponent(() => import('pages/oauth/OAuthConsent'))
  },
  {
    path: `/apps/${platform}/authorize/callback`,
    component: asyncComponent(() =>
      import('pages/app/platforms/PlatformAuthorizeCallback')
    )
  },
  {
    path: '/accounts-chooser',
    title: 'Alterar',
    component: asyncComponent(() => import('pages/shared/TenantChooser')),
    menu: { icon: 'th-large' }
  },
  {
    path: '/subscribe',
    component: asyncComponent(() =>
      import('pages/public/SubscribeSpecificPlan')
    )
  },
  {
    path: '/public/term-of-use/:tenantId/acceptance/pdf',
    component: asyncComponent(() =>
      import('pages/app/term-of-use/DigitalAcceptedCertificateView')
    )
  },
  {
    path: '/inmaintenance',
    component: asyncComponent(() => import('pages/signin/InMaintenance'))
  },
  {
    path: '/redirect',
    component: asyncComponent(() => import('pages/shared/MainRedirect'))
  },
  {
    path: '/a',
    component: (props) => <AdminContainer {...props} />,
    roles: ['Admin'],
    routes: [
      {
        path: '/customers',
        title: 'Clientes',
        resource: 'accounts',
        fixedQueryParams: { type: 'customer' },
        singularTitle: 'Cliente',
        component: asyncComponent(() =>
          import('pages/admin/accounts/AccountList')
        ),
        menu: { icon: 'user' }
      },
      {
        path: '/partners',
        title: 'Parceiros',
        resource: 'accounts',
        fixedQueryParams: { type: 'partner' },
        singularTitle: 'Parceiro',
        component: asyncComponent(() =>
          import('pages/admin/accounts/AccountList')
        ),
        menu: { icon: 'handshake' }
      },
      {
        path: '/coupons',
        title: 'Cupons',
        singularTitle: 'Cupom',
        component: asyncComponent(() =>
          import('pages/admin/coupons/CouponList')
        ),
        menu: { icon: 'ticket-alt' }
      },
      {
        path: '/subscription-plans',
        title: 'Planos',
        singularTitle: 'Plano',
        component: asyncComponent(() =>
          import('pages/admin/subscriptionPlans/SubscriptionPlanList')
        ),
        menu: { icon: 'hand-holding-usd' }
      },
      {
        path: '/cities',
        title: 'Cidades',
        singularTitle: 'Cidade',
        component: asyncComponent(() => import('pages/admin/cities/CityList')),
        menu: { icon: 'city' }
      },
      {
        path: '/announcements',
        title: 'Comunicados',
        singularTitle: 'Comunicado',
        component: asyncComponent(() =>
          import('pages/admin/announcements/AnnouncementList')
        ),
        menu: { icon: 'bullhorn' }
      },
      {
        path: '/rejection-resolutions',
        title: 'Rejeições',
        singularTitle: 'Rejeição',
        component: asyncComponent(() =>
          import('pages/admin/rejectionResolutions/RejectionResolutionList')
        ),
        menu: { icon: 'exclamation-triangle' }
      },
      {
        path: '/store-orders',
        title: 'Pedidos',
        singularTitle: 'Pedido',
        component: asyncComponent(() =>
          import('pages/admin/storeOrders/StoreOrderList')
        ),
        menu: { icon: 'shopping-cart' }
      }
    ]
  },
  {
    path: '/p',
    component: (props) => <AppContainer {...props} />,
    roles: ['*'],
    features: ['profile_customer'],
    routes: [
      {
        path: '/',
        title: 'Dashboard',
        exact: true,
        component: asyncComponent(() => import('pages/app/home/Home')),
        menu: { icon: 'tachometer-alt' }
      },
      {
        path: '/onboarding',
        title: 'Onboarding',
        exact: true,
        component: asyncComponent(() =>
          import('pages/app/onboarding/Onboarding')
        )
      },
      {
        path: '/activate',
        title: 'Ativação',
        exact: true,
        component: asyncComponent(() =>
          import('pages/app/onboarding/OnboardingActivation')
        )
      },
      {
        path: '/orders',
        title: 'Vendas',
        exact: true,
        component: asyncComponent(() => import('pages/app/orders/OrderList')),
        menu: { icon: 'shopping-cart' }
      },
      {
        path: '/invoices',
        title: 'Notas Fiscais',
        features: [INVOICE_MANAGEMENT],
        exact: true,
        component: asyncComponent(() =>
          import('pages/app/invoices/InvoiceListPage')
        ),
        menu: { icon: 'file-invoice' }
      },
      {
        path: '/inbound-invoices',
        title: 'Notas Fiscais',
        features: [INVOICE_MANAGEMENT],
        exact: true,
        component: asyncComponent(() =>
          import('pages/app/invoices/InvoiceListPage')
        )
      },
      {
        path: '/product-invoices/disablements',
        endpoint: '/product-invoices/disablements',
        title: 'Inutilizações de NF-e',
        resource: 'disablements',
        component: asyncComponent(() =>
          import('pages/app/invoices/InvoiceDisablementList')
        )
      },
      {
        path: '/customers',
        title: 'Clientes',
        component: asyncComponent(() =>
          import('pages/app/customers/CustomerList')
        ),
        menu: { icon: 'user-friends' }
      },
      {
        path: '/contributors',
        title: 'Colaboradores',
        resource: 'users',
        singularTitle: 'Colaborador',
        component: asyncComponent(() =>
          import('pages/app/contributors/CollaboratorList')
        )
      },
      {
        path: '/operation-natures',
        title: 'Naturezas de operações',
        resource: 'operation-natures',
        singularTitle: 'Natureza de operação',
        component: asyncComponent(() =>
          import('pages/app/operation-natures/OperationNatureList')
        )
      },
      {
        path: '/taxation-groups',
        title: 'Tributação',
        resource: 'taxation-groups',
        singularTitle: 'Tributação',
        component: asyncComponent(() =>
          import('pages/app/taxationGroups/TaxationGroupList')
        )
      },
      {
        path: '/products',
        title: 'Produtos',
        component: asyncComponent(() =>
          import('pages/app/products/ProductList')
        ),
        menu: { icon: 'box-open' }
      },
      {
        path: '/carriers',
        title: 'Transportadoras',
        resource: 'carriers',
        component: asyncComponent(() =>
          import('pages/app/carriers/CarrierList')
        )
      },
      {
        path: '/monthly-closing',
        title: 'Fechamento',
        component: asyncComponent(() =>
          import('pages/app/monthly-close/MonthlyClosing')
        ),
        menu: { icon: 'business-time' }
      },
      {
        path: '/platforms',
        title: 'Apps',
        component: asyncComponent(() =>
          import('pages/app/platforms/PlatformList')
        ),
        hideInactiveCompanies: true,
        menu: { icon: 'th-large' }
      },
      {
        path: '/ai-assistant',
        title: 'Assistente de IA',
        component: asyncComponent(() =>
          import('pages/app/assistant/AssistantPage')
        ),
        isAvailable: ({ user }) => isAssistantLaunched({ email: user?.email }),
        menu: { icon: 'wand-magic-sparkles', isNew: true }
      },
      {
        path: '/referral-program',
        title: 'Indique e ganhe',
        component: asyncComponent(() =>
          import('pages/app/referralProgram/ReferralProgramHome')
        ),
        menu: { icon: 'bullhorn' }
      },
      {
        path: '/referral-program-politics',
        title: 'Políticas do Programa Indique e Ganhe',
        component: asyncComponent(() =>
          import('pages/app/referralProgram/ReferralProgramPolitics')
        )
      },
      {
        path: '/notifications',
        title: 'Notificações',
        component: asyncComponent(() =>
          import('pages/app/notifications/NotificationList')
        )
      }
    ]
  },
  {
    path: '/r',
    component: (props) => <AppContainer {...props} />,
    roles: ['*'],
    features: ['profile_partner'],
    routes: [
      {
        path: '/referral-program',
        title: 'Indique e ganhe',
        component: asyncComponent(() =>
          import('pages/app/referralProgram/ReferralProgramHome')
        ),
        menu: { icon: 'bullhorn' }
      },
      {
        path: '/referral-program-politics',
        title: 'Políticas do Programa Indique e Ganhe',
        component: asyncComponent(() =>
          import('pages/app/referralProgram/ReferralProgramPolitics')
        )
      }
    ]
  },
  {
    path: '/',
    exact: true,
    redirectTo: '/redirect'
  }
];
